import { stockLine } from "../../../mocks/clueSite";

export default function UpdateTicker() {
  const doubled = [...stockLine, ...stockLine];
  return (
    <div className="sticky top-0 z-50 bg-foreground-950 text-background-100">
      <div className="ticker-paused flex items-center h-9 md:h-10 px-2 md:px-4">
        <span className="flex-none inline-flex items-center gap-1.5 mr-3 pl-1 md:pl-2 whitespace-nowrap">
          <span className="inline-flex items-center gap-1 rounded bg-primary-500 px-1.5 py-0.5 text-background-50">
            <i className="ri-flashlight-fill text-[11px]" />
            <span className="font-number font-bold tracking-wide text-xs">51黑料·线报</span>
          </span>
        </span>
        <div className="flex-1 min-w-0 overflow-hidden">
          <div className="ticker-track flex w-max items-center">
            {doubled.map((t, i) => (
              <span key={i} className="flex items-center whitespace-nowrap text-xs md:text-[13px] text-background-100/85">
                <span className="px-1 text-primary-400/80">◆</span>
                {t}
                <span className="mx-3 text-background-300/40">/</span>
              </span>
            ))}
          </div>
        </div>
        <a
          href="#guide"
          className="flex-none hidden sm:inline-flex items-center gap-1 ml-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950 whitespace-nowrap hover:bg-accent-400"
        >
          <i className="ri-upload-2-line text-sm" />
          我要投稿
        </a>
      </div>
    </div>
  );
}